import { IMaterial } from '../interfaces/i-material';

export class Material implements IMaterial {
    Id: number;
    Nome: string;
    Tipo_Id?: number;
    Categoria_Id?: number;
}